<template>
  <div class="recaptcha-error">
    <div class="title pb-4">
      <span class="h3">
        <font-awesome-icon
          icon="exclamation-triangle"
          class="text-warning"
        />

      </span>
      <span class="h3 pr-4">
        Recaptcha verification error
      </span>
    </div>
    <div class="message">
      <p>Unable to verify recaptcha response.</p>
      <p>Please reload the page and attempt payment again.</p>
      <p>If problem persists please contact the site administrator.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'square-payment-recaptcha-verification-error'
}
</script>

<style>

</style>
